import { css } from "@emotion/react";

export const stickyHeader = css`
  top: 7rem;
`;
